export default "__VITE_ASSET__DTGpJj$a__"